import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { setOnSale, setWithSubscription } from 'Pods/SearchPage/Store/actions/pricing'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

import { getPricingCheckboxFiltersConfig } from './constants'
import PriceInputs from './PriceInputs/PriceInputs'
import RangeButtons from './RangeButtons/RangeButtons'
import SubscriptionTier from './SubscriptionTier/SubscriptionTier'

function PriceContent() {
  const translate = useTranslate()
  const pageConfig = usePageConfig()

  // Same gate as the legacy listing's tier filter: without the Premium flags a tier pick would
  // dead-end (Premium empty, All == Essentials), so it falls back to the plain on/off checkbox.
  // Safe to read pageConfig directly: this content only mounts after the user opens the
  // dropdown or the drawer, never during SSR.
  const isTierFilterAvailable = !!(
    pageConfig?.subscriptionFlowEnabled
    && pageConfig?.premiumExposed
    && pageConfig?.subscriptionV17CatalogEnabled
  )

  const onSale = useSearchPageStore(state => state.onSale)
  const withSubscription = useSearchPageStore(state => state.withSubscription)

  const handleCheckboxFilterChange = useCallback((_, value, isOn) => {
    if (value === 'on_sale') {
      setOnSale(isOn)
    } else if (value === 'with_subscription') {
      setWithSubscription(isOn)
    }
  }, [])

  const selectedCheckboxFilters = useMemo(() => {
    const selected = []
    if (onSale) selected.push('on_sale')
    if (withSubscription) selected.push('with_subscription')
    return selected
  }, [onSale, withSubscription])

  const checkboxFiltersConfig = useMemo(
    () => getPricingCheckboxFiltersConfig(translate, !isTierFilterAvailable),
    [translate, isTierFilterAvailable]
  )

  return (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={checkboxFiltersConfig}
        selectedFilters={selectedCheckboxFilters}
        onFiltersChange={handleCheckboxFilterChange}
        isControlled
        useNewCheckboxes
        hideLastDivider
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
      <RangeButtons />
      <PriceInputs />
      {isTierFilterAvailable && <SubscriptionTier />}
    </>
  )
}

PriceContent.propTypes = {}

export default memo(PriceContent)
